import { useState } from "react"
import toast from "react-hot-toast";

export default function useBadRequestForm() {
    const [formErrorMessage, setFormErrorMessage] = useState(null)

    function isResponseErrorObject(response) {
        setFormErrorMessage(null);
        if (response.statusCode === 404) {
            toast.error(`${response.message.statusCode}: ${response.message.message}`);
        } else if (response.statusCode === 500) {
            toast.error(`${response.statusCode}: ${response.message}`);
        } else {
            if (typeof response.message === 'object' && response.message !== null && !Array.isArray(response.message)) {
                setFormErrorMessage(response.message);
            } else {
                setFormErrorMessage({error: response.message});
            }
        }
    }

    return {
        formErrorMessage,
        setFormErrorMessage,
        isResponseErrorObject
    }
}